<mat-toolbar color="primary" class="layout-toolbar">
  <button mat-icon-button (click)="drawer.toggle()">
    <mat-icon>menu</mat-icon>
  </button>
  <button mat-icon-button (click)="redirectHome()">
    <mat-icon>home</mat-icon>
  </button>
  <h1 class="layout-app-name">Administration Perval</h1>
</mat-toolbar>

<mat-drawer-container class="layout-drawer-container">
  <mat-drawer #drawer mode="side" [opened]="true" class="layout-drawer">
    <mat-list>
      <admin-drawer-item
        *ngFor="let item of menuItems"
        [menuItem]="item"
      ></admin-drawer-item>
    </mat-list>
  </mat-drawer>
  <mat-drawer-content class="layout-drawer-content">
    <router-outlet></router-outlet>
  </mat-drawer-content>
</mat-drawer-container>
